<template>
    <v-card color="#DCDCDC" class="pb-4" :disabled="!utc.onValidPeriod">
        <v-overlay
            v-if="!utc.onValidPeriod"
            class="align-center justify-center overlay"
        >
            <v-alert type="error">
               {{ $vuetify.lang.t('$vuetify.utc.utcCard.deviceCannotBeUsedRentalPeriod') }}
            </v-alert>
        </v-overlay>
        <v-card-title>
            <h2 class="font-weight-bold">{{ utc.denomination }}</h2>
        </v-card-title>
        <v-card v-if="!utc.loading" class="mx-4">
            
            <v-container fluid>
                <v-row justify="space-between" dense class="mb-1">
                    <v-col cols="auto">
                        <h2>{{ utc.serialnb }}</h2>
                    </v-col>
                    <v-col cols="auto" class="mr-md-16">
                        <v-icon v-if="!utc.isTempExceeds && !utc.isTempExtExceeds" color="green" size="35">mdi-thermometer</v-icon>
                        <v-icon v-else-if="utc.isTempExceeds && utc.isTempExtExceeds" color="red" size="35">mdi-thermometer-alert</v-icon>
                        <v-icon v-else color="orange" size="35">mdi-thermometer</v-icon>

                        <v-icon v-if="!utc.isSupplyExceeds" color="green" size="35">mdi-flash-outline</v-icon>
                        <v-icon v-else color="red" size="35">mdi-flash-alert-outline</v-icon>
                    </v-col>
                    <v-col cols="auto">
                        <v-icon v-if="utc.isConnected" color="green lighten-2" size="35">mdi-signal</v-icon>
                        <v-icon v-else color="red" size="35">mdi-signal-off</v-icon>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row justify="center" justify-md="space-around" class="mt-1">
                    <v-col cols="auto" md="6" lg="auto" class="pt-0">
                        <v-row align="center" justify-lg="start" class="mt-0">
                            <v-col cols="auto">
                                <v-icon color="black" size="35">mdi-camera-iris</v-icon>
                            </v-col>
                            <v-col cols="auto">
                                <h3>{{ utc.DClong }}</h3>
                            </v-col>
                        </v-row>
                        <v-row align="center" class="mt-0">
                            <v-col cols="auto">
                                <v-icon color="black" size="35">mdi-target</v-icon>
                            </v-col>
                            <v-col cols="auto">
                                <h3>{{ utc.rangeType }}</h3>
                            </v-col>
                        </v-row>
                        <v-row align="center" class="mt-0">
                            <v-col cols="auto">
                                <v-icon color="black" size="35">mdi-cctv</v-icon>
                            </v-col>
                            <v-col cols="auto">
                                <h3>V : {{ utc.hardVersion }}</h3>
                            </v-col>
                        </v-row>
                        <v-row align="center" class="mt-0">
                            <v-col cols="auto">
                                <v-icon color="black" size="35">mdi-desktop-classic</v-icon>
                            </v-col>
                            <v-col cols="auto">
                                <h3>V : {{ utc.softVersion }}</h3>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-divider vertical inset class="d-none d-md-inline-flex"></v-divider>
                    <v-col align="center" cols="auto" md="6">
                        <h3>{{ $vuetify.lang.t('$vuetify.utc.utcCard.emissivity') }} : {{ utc.emissivity }}</h3>
                        <v-divider class="mt-4 d-none d-md-block"></v-divider>
                        <h3 class="mt-4">{{ $vuetify.lang.t('$vuetify.utc.utcCard.triggerthreshold') }}</h3>
                        <h3 class="font-weight-black">{{ thresholdConverted }} °{{ utc.degFormat }}</h3>
                        <v-btn
                            dark
                            color="grey"
                            class="gradient-wintech mt-5"
                            @click="$emit('click:settings', $event)"
                            
                        >
                            <v-icon left>mdi-cog</v-icon>
                            {{ $vuetify.lang.t('$vuetify.utc.utcCard.settings') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
            
        </v-card>
    </v-card>
</template>

<style scoped>
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 1 !important;
    }
</style>

<script>
export default {
    name: "UTCCard",
    props: {
        utc: Object,
    },
    computed: {
        thresholdConverted() {
            return this.convert(this.utc.threshold)
        }
    },
    methods: {
        convert(val){
            return this.utc.degFormat === 'C' ? val : this.utc.degFormat === 'F' ? (val*9/5)+32 : Number(val)+273.15
        },
    }
}
</script>